<template>
  <div class="row">
    <!-- <div class="col-md-3"> -->
      <!-- <label for="">List of User roles</label> -->
      <!-- <ul class="list-group">
        <li
          @click="editItem(item, index)"
          class="list-group-item d-flex"
          :class="{ active: isActive == index }"
          :key="index"
          v-for="(item, index) in allItems"
        >
          <div class="align-self-start flex-fill">{{ item.name }}</div>
          <div class="align-self-end">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-chevron-right"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
          </div>
        </li>
      </ul> -->
    <!-- </div> -->
    <div class="col-md-12">
      <div class="container o-form-page">
        <o-working-overlay :working="working"></o-working-overlay>

        <o-section :title="title" @click="enableDebug($event)" :level="0">
          <item-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
          ></item-form>
          <div class="container">
            <b-row align-h="end">
              <button @click="doSave" type="button" class="btn btn-primary">
                Save
              </button>
            </b-row>
          </div>
        </o-section>
      </div>
    </div>
  </div>
</template>
      
      <script>
import {
  CreateFormPageMixin,
  CreateGroupPermissionMixin,
  UnsavedMixin,
} from "../../../../vue-ocom/mixins";
import ItemForm from "../components/ItemForm.vue";
import OActionButtons from "../../../../vue-ocom/components/forms/OActionButtons";
import OSection from "../../../../vue-ocom/components/layout/OSection";
import OWorkingOverlay from "../../../../vue-ocom/components/OWorkingOverlay";
import { mapActions } from "vuex";
import _ from "lodash";

export default {
  mixins: [
    UnsavedMixin,
    CreateFormPageMixin("ProcessTrigger", "process_trigger"),
    CreateGroupPermissionMixin("ProcessTrigger"),
  ],
  components: {
    OSection,
    OWorkingOverlay,
    OActionButtons,
    ItemForm,
  },
  data() {
    return {
      items: [],
      isActive: null,
    };
  },
  methods: {
    ...mapActions("ProcessTriggerModule", ["getAll"]),
    async getAllItems() {
      await this.getAll().then((res) => {
        this.items = _.cloneDeep(res.items);
      });
    },
    async editItem(item, index) {
      this.isActive = index;
      this.item = item;
    },
  },
  created() {
    this.getAllItems();
  },
  computed: {
    allItems() {
      return this.items;
    },
    title() {
      if (this.create) {
        return "Create Process Trigger";
      }

      return "Edit Process Trigger";
    },
  },
  watch: {
    serverErrors(oldValue, newValue) {
      this.getAllItems();
    },
  },
};
</script>